var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.66406H5C4.20435 4.66406 3.44129 4.98013 2.87868 5.54274C2.31607 6.10535 2 6.86841 2 7.66406V17.6641C2 18.4597 2.31607 19.2228 2.87868 19.7854C3.44129 20.348 4.20435 20.6641 5 20.6641H19C19.7956 20.6641 20.5587 20.348 21.1213 19.7854C21.6839 19.2228 22 18.4597 22 17.6641V7.66406C22 6.86841 21.6839 6.10535 21.1213 5.54274C20.5587 4.98013 19.7956 4.66406 19 4.66406ZM5 6.66406H19C19.2652 6.66406 19.5196 6.76942 19.7071 6.95696C19.8946 7.14449 20 7.39885 20 7.66406L12 12.5441L4 7.66406C4 7.39885 4.10536 7.14449 4.29289 6.95696C4.48043 6.76942 4.73478 6.66406 5 6.66406ZM20 17.6641C20 17.9293 19.8946 18.1836 19.7071 18.3712C19.5196 18.5587 19.2652 18.6641 19 18.6641H5C4.73478 18.6641 4.48043 18.5587 4.29289 18.3712C4.10536 18.1836 4 17.9293 4 17.6641V9.94406L11.48 14.5141C11.632 14.6018 11.8045 14.648 11.98 14.648C12.1555 14.648 12.328 14.6018 12.48 14.5141L20 9.94406V17.6641Z",
    fill: "url(#paint0_linear_432_2470)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_432_2470",
    x1: 12,
    y1: 4.66406,
    x2: 12,
    y2: 20.6641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/IconEmail.4b922c28655d39e664145e19c4e55102.svg";
export { ForwardRef as ReactComponent };